import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import CardWithIcon from "../CardWithIcon";

export function CardsWithTitle({ title, items, productCode, productType }) {
    const dontShowLink = productType.toLowerCase() === "cheques" || productType.toLowerCase() === "pagares" || productType.toLowerCase() === "cauciones";

    return (
        <div className="cot-cards-with-title">
            <h5 className="title-5">{title}</h5>

            <div className="cards-container">
                {items.map((item, i) =>
                    dontShowLink ? (
                        <div className="router-link" key={item.simbolo + i}>
                            <CardWithIcon
                                key={item.simbolo + i}
                                item={item}
                                type={
                                    title == "Volumenes"
                                        ? "vol"
                                        : title == "Tasa Promedio" || title == "Rendimiento"
                                            ? "per"
                                            : ""
                                }
                                productCode={productCode}
                            />
                        </div>
                    ) : (
                        <Link
                            data-external-check-exempt
                            className="router-link"
                            key={item.simbolo + i}
                            to={
                                productCode.toLowerCase() === "fondos"
                                    ? `/${productCode.toLowerCase()}/${item.id}/`
                                    : `/${productCode.toLowerCase()}/${item.simbolo}/`
                            }
                        >
                            <CardWithIcon key={item.simbolo + i} item={item} productCode={productCode} />
                        </Link>
                    ),
                )}
            </div>
        </div>
    );
}

export function CardsWithTitleCarousel({ title, items, productCode, productType }) {
    const dontShowLink = productType === "cheques" || productType === "pagares";

    return (
        <div className="cot-cards-with-title">
            <h5 className="title-5">{title}</h5>

            <Swiper className="cot-slider" slidesPerView={2.2} spaceBetween={4}>
                {items.map((item, i) => {
                    return (
                        <SwiperSlide key={i}>
                            {dontShowLink ? (
                                <div className="router-link" key={item.simbolo + i}>
                                    <CardWithIcon item={item} />
                                </div>
                            ) : (
                                <Link
                                    data-external-check-exempt
                                    className="router-link"
                                    key={item.simbolo + i}
                                    to={
                                        productCode.toLowerCase() === "bonos"
                                            ? `/${productCode.toLowerCase()}/${item.id}/`
                                            : `/${productCode.toLowerCase()}/${item.simbolo}/`
                                    }
                                >
                                    <CardWithIcon item={item} />
                                </Link>
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
